<template>
  <div>
    <div v-if="loading" class="text-center my-4"><b-spinner></b-spinner></div>
    <div v-else>
      <!-- Tarjetas KPI (venta neta, vs AA, vs meta, ticket promedio, clientes activos,
           % recompra, venta canal propio, ROI/ROAS). Cada tarjeta navega a su pestaña. -->
      <b-row class="mb-3">
        <b-col v-for="c in kpiCards" :key="c.key" md="3" sm="6" class="mb-2">
          <kpi-card
            :label="c.label"
            :value="c.value"
            :format="c.format"
            :comparative="c.comparative"
            :comparative-label="c.comparativeLabel"
            clickable
            @click="goTab(c.tab)"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6" class="mb-3">
          <b-card title="Mix por canal" body-class="py-2">
            <b-table small striped :items="channelMix" :fields="channelFields" show-empty
              empty-text="Sin datos.">
              <template #cell(net_sales)="d">{{ money(d.item.net_sales) }}</template>
              <template #cell(share_pct)="d">{{ num(d.item.share_pct).toFixed(1) }}%</template>
            </b-table>
          </b-card>
        </b-col>
        <b-col md="6" class="mb-3">
          <b-card title="Alertas abiertas" body-class="py-2">
            <b-table small striped :items="alerts" :fields="alertFields" show-empty
              empty-text="Sin alertas abiertas.">
              <template #cell(severity)="d">
                <b-badge :variant="d.item.severity === 'high' ? 'danger' : 'warning'">{{ d.item.severity }}</b-badge>
              </template>
            </b-table>
            <div class="text-right">
              <b-button size="sm" variant="link" @click="goTab('alerts')">Ver todas →</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-alert show variant="light" class="small">
        Paneles de <strong>satisfacción / voz del cliente</strong> y <strong>taquizas</strong>
        pertenecen a la <strong>Fase 5 (diferida)</strong> y no se muestran en la portada.
      </b-alert>
    </div>
  </div>
</template>

<script>
import KpiCard from './KpiCard.vue';
import executiveService from '@/services/executiveService';

// Pestaña 1 · Resumen ejecutivo / portada (doc 04 §3, report/exec/summary compone
// 1,2,3,5,6,12,13). Se omite el panel de satisfacción (Fase 5 diferida).
export default {
  name: 'ExecSummary',
  components: { KpiCard },
  props: { filters: { type: Object, default: () => ({}) } },
  data() {
    return {
      loading: false,
      summary: {},
      channelMix: [],
      alerts: [],
      channelFields: [
        { key: 'channel_label', label: 'Canal' },
        { key: 'net_sales', label: 'Venta neta' },
        { key: 'share_pct', label: 'Participación' }
      ],
      alertFields: [
        { key: 'alert_type', label: 'Tipo' },
        { key: 'severity', label: 'Sev.' },
        { key: 'title', label: 'Descripción' }
      ]
    };
  },
  computed: {
    kpiCards() {
      const s = this.summary || {};
      return [
        { key: 'net_sales', label: 'Venta neta', value: s.net_sales, format: 'money', comparative: s.net_sales_vs_year, comparativeLabel: 'vs AA', tab: 'sales' },
        { key: 'vs_goal', label: 'vs Meta', value: s.net_sales_vs_goal, format: 'percent', tab: 'sales' },
        { key: 'avg_ticket', label: 'Ticket promedio', value: s.avg_ticket, format: 'money', tab: 'sales' },
        { key: 'active_customers', label: 'Clientes activos', value: s.active_customers, format: 'number', tab: 'customers' },
        { key: 'repurchase_rate', label: '% Recompra', value: s.repurchase_rate, format: 'percent', tab: 'customers' },
        { key: 'own_channel_sales', label: 'Venta canal propio', value: s.own_channel_sales, format: 'money', tab: 'delivery' },
        { key: 'loyalty_points', label: 'Puntos otorgados', value: s.points_earned, format: 'number', tab: 'loyalty' },
        { key: 'roi', label: 'ROI / ROAS', value: s.roas, format: 'percent', tab: 'finance' }
      ];
    }
  },
  watch: {
    filters: { deep: true, handler() { this.load(); } }
  },
  mounted() { this.load(); },
  methods: {
    money(v) { const n = Number(v || 0); return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    num(v) { return Number(v || 0); },
    goTab(tab) { this.$emit('go-tab', tab); },
    load() {
      this.loading = true;
      executiveService.run('summary', this.filters)
        .then((res) => {
          const d = res.data || {};
          this.summary = d.summary || {};
          this.channelMix = (d.summary && d.summary.channel_mix) || (d.rows || []);
          this.alerts = (d.summary && d.summary.alerts) || [];
        })
        .catch((err) => this.$emit('error', err))
        .finally(() => { this.loading = false; });
    }
  }
}
</script>
